import AddressSearchCore from './op/search-core';
import { ORDERPROCESS_EDGE_API, TranslationNamespaces } from '~/lib/constants';
import { AddressLookup } from './op/types';

type props = {
  onSelect: (a: AddressLookup) => void;
  countryIsoCode: string;
  search: string;
  required: boolean;
};

const AddressTypeahead = ({ onSelect, countryIsoCode, search, required }: props) => (
  <AddressSearchCore
    apiPath={ORDERPROCESS_EDGE_API}
    translationNamespace={TranslationNamespaces.SMARTSEND}
    countryIsoCode={countryIsoCode}
    postcode={search}
    onSelected={onSelect}
    type={'Origin'}
    errors={{}}
    optional={!required}
  />
);

export default AddressTypeahead;
